import { post } from "aws-amplify/api";
import { put } from "aws-amplify/api";
import { getIdToken } from "utils";

const apiClient = {
  async handlePost({
    apiName,
    path,
    headers = {},
    body = {},
    queryParams = {},
  }) {
    try {
      // Automatically add access token if not explicitly provided
      if (!headers.Authorization) {
        const idToken = await getIdToken() ;

        headers.Authorization = idToken.toString();
      }

      const postResult = await post({
        apiName,
        path,
        options: {
          headers,
          body,
          queryParams,
        },
      });

      const data = await postResult.response;
      return await data.body.json();
    } catch (error) {
      console.error("API post error:", error);
      throw error;
    }
  },
  async handlePut({ apiName, path, headers, body, queryParams }) {
    const { response } = await put({
      apiName,
      path,
      options: { body, headers, queryParams },
    });
    return response;
  },
};

export default apiClient;
